/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "flex"
};
const _hoisted_2 = {
  class: "flex"
};
import { apiSendSms, apiSetPhone } from '@/api/user';
import { useGetVerCode } from '@ultra/share/hooks/useGetVercode';
export default /*#__PURE__*/_defineComponent({
  __name: 'editPhone',
  props: {
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const editPhoneForm = ref({
      old_phone_code: '',
      phone: '',
      phone_code: ''
    });
    const editPhoneRules = reactive({
      old_phone_code: {
        required: true,
        message: '请输入验证码',
        trigger: 'blur'
      },
      phone: [{
        required: true,
        message: '请输入新手机号',
        trigger: 'blur'
      }],
      phone_code: {
        required: true,
        message: '请输入验证码',
        trigger: 'blur'
      }
    });
    const ruleFormPhoneRef = ref();
    const getVerCode = async () => {
      const params = {
        Phone: props.userInfo.Phone,
        Type: 6
      };
      return await apiSendSms(params);
    };
    const {
      codeState,
      getVerCodeFn
    } = useGetVerCode(getVerCode);
    const phoneTimer = ref();
    const phoneCodeState = ref({
      isClick: true,
      time: 60,
      text: '获取验证码',
      isLoading: false
    });
    const getVerCodeNewPhone = async formEl => {
      if (!formEl) return;
      formEl.validateField('phone', async valid => {
        if (valid) {
          let params = {};
          params.Phone = editPhoneForm.value.phone;
          params.Type = 6;
          phoneCodeState.value.isLoading = true;
          const res = await apiSendSms(params);
          phoneCodeState.value.isLoading = false;
          if (res.code === 0) {
            phoneCodeState.value.isClick = false;
            phoneTimer.value = setInterval(() => {
              phoneCodeState.value.text = phoneCodeState.value.time + 's';
              if (phoneCodeState.value.time <= 0) {
                clearInterval(phoneTimer.value);
                phoneCodeState.value.text = '重新获取';
                phoneCodeState.value.isClick = true;
              }
              phoneCodeState.value.time--;
            }, 1000);
          }
        }
      });
    };
    const handleOk = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          apiSetPhone({
            ...editPhoneForm.value
          }).then(res => {
            if (res.code === 0) {
              emits('success');
              ruleFormPhoneRef.value.resetFields();
            }
          });
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      return _openBlock(), _createBlock(_component_u_card_pane, {
        name: "editPhone"
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_Teleport, {
          to: "#editPhone"
        }, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => handleOk(_unref(ruleFormPhoneRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        })])), _createVNode(_component_el_form, {
          ref_key: "ruleFormPhoneRef",
          ref: ruleFormPhoneRef,
          model: _unref(editPhoneForm),
          rules: _unref(editPhoneRules),
          "label-width": "130px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "旧手机号",
            prop: "name"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
              "model-value": __props.userInfo.Phone,
              disabled: "",
              style: {
                "width": "300px"
              }
            }, null, 8, ["model-value"]), _createVNode(_component_el_button, {
              class: "marginL20",
              type: "primary",
              loading: _unref(codeState).isLoading,
              disabled: !_unref(codeState).isClick,
              onClick: _unref(getVerCodeFn)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(codeState).text), 1)]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"])])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "旧手机号验证码",
            prop: "old_phone_code"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(editPhoneForm).old_phone_code,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(editPhoneForm).old_phone_code = $event),
              style: {
                "width": "300px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "新手机号",
            prop: "phone"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
              modelValue: _unref(editPhoneForm).phone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(editPhoneForm).phone = $event),
              style: {
                "width": "300px"
              }
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              class: "marginL20",
              type: "primary",
              loading: _unref(phoneCodeState).isLoading,
              disabled: !_unref(phoneCodeState).isClick,
              onClick: _cache[3] || (_cache[3] = $event => getVerCodeNewPhone(_unref(ruleFormPhoneRef)))
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(phoneCodeState).text), 1)]),
              _: 1
            }, 8, ["loading", "disabled"])])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "新手机号验证码",
            prop: "phone_code"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(editPhoneForm).phone_code,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(editPhoneForm).phone_code = $event),
              style: {
                "width": "300px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      });
    };
  }
});